import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { contactFormUrl, footerLinks, type AppLocale } from '../app/config';

type FooterProps = {
  currentLocale: AppLocale;
};

export function Footer({ currentLocale }: FooterProps) {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className='footer'>
      <div className='footer-content'>
        {/*
          Social links are temporarily hidden — restore this block (together
          with the socialLinks array usage) once official accounts are ready.

        <div className='social-links'>
          {socialLinks.map(link => (
            <a
              key={link.id}
              href={link.href}
              target='_blank'
              rel='noopener noreferrer'
              className='social-link'
              aria-label={link.label}
            >
              <i className={link.icon} aria-hidden='true' />
            </a>
          ))}
        </div>
        */}
        <div className='footer-links'>
          {footerLinks.map(link =>
            link.id === 'contact' ? (
              <a
                href={contactFormUrl}
                key={link.id}
                target='_blank'
                rel='noopener noreferrer'
              >
                {t(`footer.${link.id}`)}
              </a>
            ) : (
              <Link key={link.id} to={`/${currentLocale}/${link.id}`}>
                {t(`footer.${link.id}`)}
              </Link>
            )
          )}
        </div>

        <p>
          &copy; {currentYear} {t('seo.siteTitle')} |{' '}
          <a href='https://devdom.ru' target='_blank' rel='noopener noreferrer'>
            {t('footer.madeBy')}
          </a>
        </p>
      </div>
    </footer>
  );
}
